export const AUDIO_OFF = 'AUDIO_OFF';
export const AUDIO_ON = 'AUDIO_ON';

export const CHARACTER_SELECT_APPLE = 'CHARACTER_SELECT_APPLE';
export const CHARACTER_SELECT_ONION = 'CHARACTER_SELECT_ONION';

export const GAME_PLAY_LEVEL_ = 'GAME_PLAY_LEVEL_';
export const GAME_PAUSE = 'GAME_PAUSE';
export const GAME_RESUME = 'GAME_RESUME';
export const GAME_RESTART = 'GAME_RESTART';
export const GAME_EXIT = 'GAME_EXIT';

export const VIEW_SCREEN_WELCOME = 'VIEW_SCREEN_WELCOME';
export const VIEW_SCREEN_INSTRUCTIONS = 'VIEW_SCREEN_INSTRUCTIONS';
export const VIEW_SCREEN_CUTSCENE = 'VIEW_SCREEN_CUTSCENE';
export const VIEW_SCREEN_CHARACTER_SELECT = 'VIEW_SCREEN_CHARACTER_SELECT';
export const VIEW_SCREEN_LEVEL_WIN = 'VIEW_SCREEN_LEVEL_WIN';
export const VIEW_SCREEN_LEVEL_LOSE = 'VIEW_SCREEN_LEVEL_LOSE';
export const VIEW_SCREEN_GAME_COMPLETE = 'VIEW_SCREEN_GAME_COMPLETE';
export const VIEW_SCREEN_PAUSE = 'VIEW_SCREEN_PAUSE';
export const VIEW_SCREEN_CREDITS = 'VIEW_SCREEN_CREDITS';

export const SKIP_CUTSCENE = 'SKIP_CUTSCENE';

export const getLevelCompleteString = (level) => {
  return 'GAME_PLAY_LEVEL_' + level + '_COMPLETE';
};

export const getLevelString = (level) => {
  return 'GAME_PLAY_LEVEL_' + level;
};

export const getLevelLoseString = (level) => {
  return 'GAME_LOSE_LEVEL_' + level;
};

export const getReferrerString = (url) => {
  return 'REFERRER_URL_' + url;
};
